import React, { useMemo } from 'react';
import { abbreviateNumber } from '@pascal/pascal-core';
import { defineChipColor } from '../../helpers/chipColor';
import { BET_TYPE } from '../../enums/actionTypes';

function SideBet({
  side,
  handleDoChip,
  boxIndex,
  boxAmountByBetType,
  quickBets,
  sideBetType,
  activeFreeBet,
  sideBetPossibleWinOdd,
  calculatedSideBets,
  isBetsClosed,
  innerContent,
  odd,
}) {
  const calculatedSideBetAmount = useMemo(() => {
    if (!calculatedSideBets) return { amount: boxAmountByBetType[sideBetType]?.amount };
    const sideBetWinning = calculatedSideBets.find((item) => item.type === sideBetType);
    return { winAmount: sideBetWinning?.winAmount || null };
  }, [calculatedSideBets, boxAmountByBetType, sideBetType]);

  return (
    <div
      className={`tb-sidebet ${
        boxAmountByBetType[BET_TYPE.main]?.amount &&
        !boxAmountByBetType[sideBetType]?.amount &&
        !isBetsClosed
          ? ''
          : ''
      } ${side} ${sideBetPossibleWinOdd ? 'active' : ''}`}
      onClick={() => handleDoChip(boxIndex, sideBetType)}
    >
      <div className='tb-sidebet-click-target' />
      <span
        className={`tb-player-side-chip  ${
          activeFreeBet.id &&
          (calculatedSideBetAmount?.winAmount
            ? calculatedSideBetAmount?.winAmount
            : calculatedSideBetAmount.amount)
            ? 'tb-chip free-chip'
            : defineChipColor(
                calculatedSideBetAmount?.winAmount
                  ? calculatedSideBetAmount?.winAmount
                  : calculatedSideBetAmount.amount || 0,
                quickBets
              ) || ''
        } ${
          abbreviateNumber(
            calculatedSideBetAmount?.winAmount
              ? calculatedSideBetAmount?.winAmount
              : calculatedSideBetAmount.amount || 0
          )?.toString().length > 3
            ? ''
            : 'large'
        }`}
      >
        {(
          calculatedSideBetAmount?.winAmount
            ? calculatedSideBetAmount?.winAmount
            : calculatedSideBetAmount.amount || 0
        )
          ? abbreviateNumber(
              calculatedSideBetAmount?.winAmount
                ? calculatedSideBetAmount?.winAmount
                : calculatedSideBetAmount.amount || 0
            )
          : null}
      </span>
      <span className='side-shape-inner-text'>{innerContent}</span>
      <span className='side-shape-odd'>{odd ? `${odd}x` : ''}</span>
    </div>
  );
}

export default SideBet;
